import AppRoutes from "./routes/routes";
import { ThemeProvider } from "./theme/theme-provider";
import { ThemeToggle } from "./theme/theme-toggle";

function App() {
    return (
        <ThemeProvider>
            <div className="dark:bg-gray-900 bg-gray-100 min-h-screen">
                <AppRoutes />
                <ThemeToggle />
            </div>
        </ThemeProvider>
    );
}

export default App;
